export var ServiceSource = /*#__PURE__*/ function(ServiceSource) {
    ServiceSource["Draft"] = "draft";
    ServiceSource["Amendment"] = "amendment";
    return ServiceSource;
}({});
export var EffectiveDateSource = /*#__PURE__*/ function(EffectiveDateSource) {
    EffectiveDateSource["System"] = "setBySystem";
    EffectiveDateSource["User"] = "setByUser";
    return EffectiveDateSource;
}({});
export var ServiceStatusType = /*#__PURE__*/ function(ServiceStatusType) {
    /** A new service that wasn't approved yet by the client. */ ServiceStatusType["AwaitingApproval"] = "awaitingApproval";
    /** An approved service is active. */ ServiceStatusType["Approved"] = "approved";
    /** An approved service with some unapproved amendments. */ ServiceStatusType["Amended"] = "amended";
    /** A service that was completed. For example, approval services will be completed after billed once. */ ServiceStatusType["Completed"] = "completed";
    /** An approved service which was canceled by the vendor. */ ServiceStatusType["Terminated"] = "terminated";
    /** An awaitingApproval service which was canceled by the vendor. */ ServiceStatusType["Canceled"] = "canceled";
    return ServiceStatusType;
}({});
export var ServiceChangeItemType = /*#__PURE__*/ function(ServiceChangeItemType) {
    ServiceChangeItemType["Pricing"] = "pricing";
    ServiceChangeItemType["Discount"] = "discount";
    ServiceChangeItemType["BillingTrigger"] = "billingTrigger";
    ServiceChangeItemType["Description"] = "description";
    ServiceChangeItemType["PriceIncrease"] = "priceIncrease";
    ServiceChangeItemType["IncludedServicesDescription"] = "includedServicesDescription";
    return ServiceChangeItemType;
}({});
